function About() {
  return (
    <>
    <section className='abt_section pt-10 pb-9 md:mx-0 mx-3'>
      <div className='container mx-auto'>
          <div className='abt_title max-w-4xl mx-auto'>
            <h1 className='text-mydarkcolor font-primary text-center text-4xl font-bold pb-4 mb-5'>About us</h1>

            <p className='text-dark font-primary text-base leading-7 mb-4 text-center'>
            Founded in 2013, Wholesale Xpress was built on a clear mission: to deliver exceptional products, competitive pricing, and outstanding service to convenience stores and smoke shops throughout the region. From day one, our focus has been on making life easier for our customers—helping them stock the products their customers want, at prices that keep them profitable and competitive.
            </p>
<div className="grid grid-cols-1 md:grid-cols-12 p-5 gap-5 max-w-4xl mx-auto items-center">
  <div className="md:col-span-8 col-span-12">
    <p className='text-dark font-primary text-base leading-7 mb-4 text-center'> <strong>Adnan Virani</strong>, our owner, has always believed that strong relationships and reliability are the cornerstones of good business. Under his leadership, Wholesale Xpress has grown from a small local supplier into a trusted partner serving countless businesses. We’re proud of the reputation we’ve earned for honesty, speed, and a deep understanding of what our customers need to succeed.</p>
  </div>
  <div className="md:col-span-4 col-span-12  flex justify-center">
      <img className=' rounded-lg' alt='Adnan Virani' src={require('../Images/adnan.jpeg')}/>
  </div>
</div>

<p className='text-dark font-primary text-base leading-7 mb-4 text-center'>Today, our team is committed to carrying those founding values forward. We offer an extensive, carefully curated selection of convenience store and smoke shop products, backed by the kind of attentive, personalized service that sets us apart from larger distributors. Whether you’re placing your first order or you’ve been with us for years, you can rely on our unwavering commitment to quality, competitive pricing, and genuine customer care.</p>
      <p className='text-dark font-primary text-base leading-7 text-center'>At Wholesale Xpress, we don’t just sell products—we help your business grow.</p>
          </div>
      </div>
    </section>
    {/* <section className='abt_btm_img text-center'>
      <img src={require('../Images/abt_page_banner.png')}/>
    </section> */}
    </>
  )
}

export default About